import { ChangeEvent } from 'react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';

import {
    updateFilter,
    propertyAddedSelector,
    underOfferOrSoldSelector
} from '@zoopla/redux-reducer-filters';
import {
    FiltersCheckBox,
    RadioButtonGroup,
    SometimesInlineRadioWrapper
} from './Filters.styles';
import { SearchPageType } from '@zoopla/listing-search-context';

interface Props {
    searchPageType: SearchPageType;
}

export const SelectAddedToSite: React.FC<Props> = ({ searchPageType }) => {
    const reduxDispatch = useDispatch();

    const {
        selectedValue: propertyAddedSelectedValue,
        options: propertyAddedOptions
    } = useSelector(propertyAddedSelector);

    const { selectedValue: underOfferOrSoldSelectedValue } = useSelector(
        underOfferOrSoldSelector
    );

    const onPropertyAddedChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyAdded', evt.currentTarget.value));
    };

    const onUnderOfferOrSoldChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(
            updateFilter('underOfferOrSold', evt.currentTarget.checked)
        );
    };

    return (
        <>
            <RadioButtonGroup>
                {propertyAddedOptions?.map((option) => (
                    <SometimesInlineRadioWrapper key={option.value}>
                        <Radio
                            label={option.label}
                            value={option.value}
                            id={option.value || 'added-anytime'}
                            onChange={onPropertyAddedChange}
                            checked={
                                option.value === propertyAddedSelectedValue
                            }
                        />
                    </SometimesInlineRadioWrapper>
                ))}
            </RadioButtonGroup>

            {searchPageType === 'for-sale' && (
                <FiltersCheckBox
                    label="Include under offer or sold STC"
                    id="underOffer"
                    data-testid="filters-modal_underOffer"
                    checked={underOfferOrSoldSelectedValue}
                    onChange={onUnderOfferOrSoldChange}
                />
            )}
        </>
    );
};
